import { Badge, Flex } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import React from 'react';
import { theme } from '../consilitheme';

const TagList = ({
  baseTags = [],
  activeTopics = [],
  setActiveTopics,
  headerTags = false,
  defaultOutline = false,
  removableHint = false,
  large = false,
  clickable = false,
  tagColor = '',
  tagType = '',
  removeTag,
}) => {
  const handleTagClick = (tag) => {
    if (!setActiveTopics) {
      return;
    }
    if (activeTopics.includes(tag)) {
      removeTag(tag, tagType);
    } else {
      setActiveTopics([...activeTopics, tag]);
    }
  };
  const calculateBadgeVariant = (tag) => {
    if (large || defaultOutline) {
      return 'light';
    }
    return activeTopics.includes(tag) ? 'filled' : 'outline';
  };

  const renderXIcon = () => {
    if (headerTags || removableHint) {
      return <IconX style={{ marginLeft: '0.5rem' }} size={16} />;
    }
    return null;
  };

  return (
    <Flex justify="between" align="center" wrap="wrap">
      {baseTags.map((tag, index) => (
        <div key={index}>
          <Badge
            ml="0"
            mr="sm"
            variant={calculateBadgeVariant(tag)}
            onClick={() => handleTagClick(tag)}
            style={{ cursor: clickable ? 'pointer' : 'text' }}
            color={tagColor}
            p={large ? theme.padding.md : theme.padding.sm}
            tt="none"
            m={theme.padding.xs}
            lts={'0px'}
          >
            <div
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                fontSize: large ? '14px' : '12px',
              }}
            >
              {tag}
              {renderXIcon()}
            </div>
          </Badge>
        </div>
      ))}
    </Flex>
  );
};

export default TagList;
